// extracted by mini-css-extract-plugin
module.exports = {"whole-home-F":"F_whole-home-F__LbTeK"};